<script lang="ts" setup>
import { titleBar } from '@/composables/menu/title'
import { useI18n } from 'vue-i18n'
import { type PublicFigureCategory, getPublicFigureCategories } from '@/composables/memorize/memorize'
import { CODE_OK } from '@/apis/code'
import PublicFigureIntroCard from '@/components/business/life/PublicFigureIntroCard.vue'

const { t } = useI18n()
const route = useRoute()
const requestURL = useRequestURL()

const canonicalUrl = computed(() => `${requestURL.origin}${route.path}`)
const pageTitle = computed(() => t('m.public_figure_categories'))
const pageDescription = computed(() => '按领域分类的公众人物纪念馆列表')

useSeoMeta({
  title: pageTitle,
  ogTitle: pageTitle,
  description: pageDescription,
  ogDescription: pageDescription,
  ogUrl: canonicalUrl,
  twitterCard: 'summary_large_image'
})

useHead({
  link: [
    {
      rel: 'canonical',
      href: canonicalUrl
    }
  ]
})

onMounted(() => {
  titleBar.value.hideBack = false
  titleBar.value.backable = true
  titleBar.value.transparent = false
  titleBar.value.title = t('m.public_figure_categories')
})

const nuxtApp = useNuxtApp() as any
if (!nuxtApp.payload.data) {
  nuxtApp.payload.data = {}
}
if (nuxtApp.static && !nuxtApp.static.data) {
  nuxtApp.static.data = {}
}

const publicFigureCategoriesList = useState<PublicFigureCategory[]>('public-figure-categories-list', () => [])

const { data: ssrData } = await useAsyncData('public-figure-categories-data', async () => {
  const { data } = await getPublicFigureCategories()
  return data.value
})

watch(
  () => ssrData.value,
  (value) => {
    if (value && value.code === CODE_OK) {
      publicFigureCategoriesList.value = (value.data as PublicFigureCategory[]) ?? []
    }
  },
  { immediate: true }
)
</script>

<template>
  <BaseLayout>
    <OpenListLayout title="公众人物的纪念馆列表">
      <PublicFigureIntroCard class="mb-4" />
      <div font-bold my-4>按领域分类排列</div>
      <OpenListItem
        v-for="(stat, index) in publicFigureCategoriesList"
        :key="index"
        :to="`/memorial/publicFigure/${stat.key}?name=${stat.name}`"
        :label="stat.name"
        :count="stat.count" />
    </OpenListLayout>
  </BaseLayout>
</template>

<style scoped></style>
